import React from 'react';
import PropTypes from 'prop-types';


import Page from 'components/Page';
import RadioList from 'components/RadioList';
import {BigRedButton} from 'components/Button';

import handleInputChange from 'utils/handleInputChange';
import {numberWithCommas} from 'utils';

import './style.css';

/* eslint-disable max-len */
export class InterestInvestment extends React.Component {
  constructor() {
    super();

    // default props
    this.state = {};

    // handlers
    this.handleInputChange = handleInputChange.bind(this);
    this.handlePageSubmit = this.handlePageSubmit.bind(this);
  }
  getAmount() {
    return parseInt(this.state.amount, 10);
  }
  handlePageSubmit() {
    // dispatch submit
    this.props.submit({
      amount: parseInt(this.state.amount, 10),
      risk: this.state.risk,
    });
  }
  canSubmit() {
    return (this.getAmount() > 0) && this.state.risk;
  }
  renderAmount() {
    // 5000 => $5,000
    if (this.state.amount) {
      return `$${numberWithCommas(this.getAmount())}`;
    }
    return '';
  }
  render() {
    return (
      <section className="pageContainer">
        <Page>
          <h2>Investment</h2>
          <p>How much would you like to invest?</p>
          <input className="input_dollar" type="number" name="amount" min="0" step="5000" onChange={this.handleInputChange} data-test="investment_amount" />
          <RadioList>
            <p>
              <input type="checkbox" name="risk" id="investment_risk" onChange={this.handleInputChange} data-test="investment_risk" />
              <label htmlFor="investment_risk">You understand all the risks of investing, including the risk that you could lose all your money</label>
            </p>
          </RadioList>
          <footer styleName="footer">
            <BigRedButton onClick={this.handlePageSubmit} disabled={!this.canSubmit()} data-test="investment_submit" >
              Commit to invest {this.renderAmount()}
            </BigRedButton>
          </footer>
        </Page>
      </section>
    );
  }
}
/* eslint-enable max-len */

InterestInvestment.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default InterestInvestment;



// WEBPACK FOOTER //
// ./web/flows/interest/investment/component.js